import { Injectable } from '@angular/core';
import { CloudDriveProvider } from "@app/models/clouddrive/clouddrive-provider.model";
import { HttpClient } from '@angular/common/http';
import { SaveFile } from '../../models/filemanagement/filemanagement.save-file.model';
import { CloudDriveService } from "@app/services/clouddrive/clouddrive.service";

@Injectable({ providedIn: "root" })
export class FileService {

  private service = 'FileService';

  private isFileBeingStreamed: boolean = false;

  constructor(private http: HttpClient, public cloudDriveService: CloudDriveService) {
    this.cloudDriveService.getUserProvider().subscribe(provider => {
      this.isFileBeingStreamed = provider === CloudDriveProvider.Cloud;
    });
  }

  public getList(index: number, categoryId: number): any {
    return this.http.get(`api/${this.service}/list-with-categoryId/${categoryId}/${index}`);
  }

  public uploadFile(file, uniqueId) {
    return this.http.post(`api/${this.service}/upload-file/${uniqueId}`, file, { reportProgress: true, observe: 'events' });
  }

  public saveAsset(saveFile: SaveFile) {
    return this.http.post(`api/${this.service}/save-asset`, saveFile);
  }

  public delete(id: number) {
    return this.http.delete(`api/${this.service}/delete/${id}`);
  }

  public listCategoryIds(id: number) {
    return this.http.get(`api/${this.service}/list-category-ids/${id}`);
  }

  public downloadZip(categoryId: number): any {
    if (this.isFileBeingStreamed)
      return this.http.get(`api/${this.service}/download-zip/${categoryId}`, { responseType: "blob" });
    else
      return this.http.get(`api/${this.service}/download-zip/${categoryId}`, { responseType: "json" });
  }

  public downloadFile(id: number): any {
    if (this.isFileBeingStreamed)
      return this.http.get(`api/${this.service}/download-file/${id}`, { responseType: "blob" });
    else
      return this.http.get(`api/${this.service}/download-file/${id}`, { responseType: "json" });
  }
  public deleteSubfolderUnderUserFolder(subfolderName: string): any {
    return this.http.delete(`api/${this.service}/deleteSubfolderUnderUserFolder/${subfolderName}`);
  }
}
